import { create } from "mutative";
import { useStore } from "../../config/store";
import { getEditOrder } from "./getEditOrder";
import { fns, libTypes } from "@holta/lib";
import { getMergedOrder } from "./getMergedOrder";
import { getMergedOrderItem } from "./getMergedOrderItem";



export const setCarcaseItemWidth = (width: number) => {
    
    const editOrder = getEditOrder();
    const mergedOrder = getMergedOrder();
    const mergedOrderItem = getMergedOrderItem();

    
    if (mergedOrderItem && fns.order_item.isCarcaseItem(mergedOrderItem)) {

        const currentOrderItem = mergedOrder.items.find((item) => item.id === mergedOrderItem.id) as libTypes.CarcaseOrderItem;

        if (currentOrderItem && currentOrderItem?.wEdited === width || currentOrderItem?.w === width) {
            useStore.setState({
                editOrder: create(editOrder, draft => {
                    (draft.newValues.orderItem as libTypes.EditedCarcaseOrderItem).wEdited = null;
                })
            });
        } else if (mergedOrderItem.w === width) {
            useStore.setState({
                editOrder: create(editOrder, draft => {
                    (draft.newValues.orderItem as libTypes.EditedCarcaseOrderItem).wEdited = null;
                })
            });
        } else {
            useStore.setState({
                editOrder: create(editOrder, draft => {
                    (draft.newValues.orderItem as libTypes.EditedCarcaseOrderItem).wEdited = fns.order_item.set.wEdited(width, mergedOrderItem.soldByM2);;
                })
            });
            
        }
    }

};